import InfoCard from 'common/ui/info-card';
import { Link } from 'react-router-dom';
import { formatDateTime } from 'utils/formatDate';

// ─── Industry detail ──────────────────────────────────────────────────────────

export const IndustryDetail = ({ item }) => {
  const { code, name, name_en, created_at, updated_at } = item || {};
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <InfoCard label="Code" value={code ?? '-'} />
      <InfoCard label="Name" value={name ?? '-'} className="md:col-span-2" />
      <InfoCard
        label="Name (EN)"
        value={name_en || '-'}
        className="md:col-span-2"
      />
      <InfoCard label="Created At" value={formatDateTime(created_at)} />
      <InfoCard label="Updated At" value={formatDateTime(updated_at)} />
    </div>
  );
};

// ─── SuperSector detail ───────────────────────────────────────────────────────

export const SuperSectorDetail = ({ item }) => {
  const { code, name, name_en, industry_code, created_at, updated_at } =
    item || {};
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <InfoCard label="Code" value={code ?? '-'} />
      <InfoCard label="Name" value={name ?? '-'} className="md:col-span-2" />
      <InfoCard
        label="Name (EN)"
        value={name_en || '-'}
        className="md:col-span-2"
      />
      <InfoCard
        label="Industry"
        value={
          industry_code ? (
            <Link to={`/catalog/stock-icb/industries/${industry_code}`}>
              {industry_code}
            </Link>
          ) : (
            '-'
          )
        }
      />
      <InfoCard label="Created At" value={formatDateTime(created_at)} />
      <InfoCard label="Updated At" value={formatDateTime(updated_at)} />
    </div>
  );
};

// ─── Sector detail ────────────────────────────────────────────────────────────

export const SectorDetail = ({ item }) => {
  const { code, name, name_en, supersector_code, created_at, updated_at } =
    item || {};
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <InfoCard label="Code" value={code ?? '-'} />
      <InfoCard label="Name" value={name ?? '-'} className="md:col-span-2" />
      <InfoCard
        label="Name (EN)"
        value={name_en || '-'}
        className="md:col-span-2"
      />
      <InfoCard
        label="SuperSector"
        value={
          supersector_code ? (
            <Link to={`/catalog/stock-icb/supersectors/${supersector_code}`}>
              {supersector_code}
            </Link>
          ) : (
            '-'
          )
        }
      />
      <InfoCard label="Created At" value={formatDateTime(created_at)} />
      <InfoCard label="Updated At" value={formatDateTime(updated_at)} />
    </div>
  );
};

// ─── SubSector detail ─────────────────────────────────────────────────────────

export const SubSectorDetail = ({ item }) => {
  const { code, name, name_en, sector_code, created_at, updated_at } =
    item || {};
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <InfoCard label="Code" value={code ?? '-'} />
      <InfoCard label="Name" value={name ?? '-'} className="md:col-span-2" />
      <InfoCard
        label="Name (EN)"
        value={name_en || '-'}
        className="md:col-span-2"
      />
      <InfoCard
        label="Sector"
        value={
          sector_code ? (
            <Link to={`/catalog/stock-icb/sectors/${sector_code}`}>
              {sector_code}
            </Link>
          ) : (
            '-'
          )
        }
      />
      <InfoCard label="Created At" value={formatDateTime(created_at)} />
      <InfoCard label="Updated At" value={formatDateTime(updated_at)} />
    </div>
  );
};
